module.exports = __webpack_public_path__ + "img/meir.5df6f9fe.png";